import React from 'react';
import { makeStyles, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
	progressContainer: {
		display: 'flex',
		justifyContent: 'center',
	},
	progress: {
		color: theme.palette.pink
	},
}));

const Progress = ({ status, className, ...other }) => {
	const classes = useStyles();

	return (
		status ?
			<div className={classes.progressContainer}>
				<CircularProgress className={clsx(classes.progress, className)} {...other} />
			</div>
			:
			<></>
	);
};

Progress.propTypes = {
	status: PropTypes.bool,
};

export default Progress;
